import {MatIcon} from '@angular/material/icon';
import {ChangeDetectionStrategy, Component, TemplateRef, ViewChild} from '@angular/core';
import {RectangularButtonContentContext} from '@aviary/buttons/button.types';
import {NgClass, NgTemplateOutlet} from '@angular/common';
import {TruncateDirective} from '@aviary/directives/truncate.directive';

@Component({
  selector: 'mx-rectangular-button-content',
  templateUrl: './rectangular-button-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, NgTemplateOutlet, TruncateDirective, NgClass]
})
export class RectangularButtonContentComponent {
  @ViewChild('content', {static: true}) public content: TemplateRef<RectangularButtonContentContext>;
}
